import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import ThreeColumns from "./three-columns";
import FooterTwo from "../../../layout/footers/footer-two";

const PortfolioThreeColumns = () => {
    return (
        <>
            <SEO pageTitle="Portfolio"/>
            <HeaderTwo/>
            <BreadCrumb title="Portfolio" items={[
                {label: "Portfolio"},
            ]}/>
            <ThreeColumns/>
            <FooterTwo/>
        </>
    );
};

export default PortfolioThreeColumns;